import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createDFWPContactList = (payload) => post(baseURL + url.DFWP_CONTACT_LIST, payload);
export const getDFWPContactListDetails = (id) => get(`${baseURL + url.DFWP_CONTACT_LIST}/${id}`);
export const updateDFWPContactList = (id, payload) => put(`${baseURL + url.DFWP_CONTACT_LIST}/${id}`, payload);
export const deleteDFWPContactList = (id) => remove(`${baseURL + url.DFWP_CONTACT_LIST}/${id}`);
